<template>
    <div class="testConfiguration" v-if="testConfiguration">
        <div class="backButton">
            <button @click="goToAccordion"><i class="fas fa-arrow-left-long"></i> Back to Accordion</button>
        </div>
        <h1>{{testConfiguration.accordionCode}} Test Scenarios</h1>
        <div class="formRow surveyCode">
            <p><b>Survey Code:</b></p>
            <select v-model="testConfiguration.surveyID" @blur="saveTestConfiguration('surveyID')">
                <option :value="0">-- No Survey --</option>
                <option v-for="survey in surveys" :key="survey.id" :value="survey.id">{{ survey.code }}</option>
            </select>
        </div>   
        <h4>Test Scenarios</h4>
        <select v-model="selectedScenario" @change="processSurvey(testConfiguration.survey, selectedScenario)">
            <option v-for="testScenario in testConfiguration.testScenarios" :value="testScenario" :key="testScenario.id">{{ testScenario.description }}</option>
        </select>
        <ItemModal :itemName="'Test Scenario'"
                        :formRows="testScenarioFormRows"
                        :saveItemFunction="saveNewTestScenario"
                        :refreshItemsFunction="getData"
                        :isActive="true"></ItemModal>
        <button v-if="this.selectedScenario" class="testButton" @click="goToAccordionTest">Test Accordion</button>
        <div class="childObject" v-if="selectedScenario">
            <button class="deleteButton" @click="deleteTestScenario">
                <i class="fas fa-trash-can"></i>
            </button>
            <p><b>Description</b></p>
            <div class="flexBreak"></div>
            <textarea v-model="selectedScenario.description" @blur="saveTestScenario(selectedScenario, 'description')"></textarea>
            <h4>Data</h4>
            <div class="grandChildObject" v-for="testScenarioData in selectedScenario.testScenarioData" :key="testScenarioData.id">
                    <button class="deleteButton" @click="deleteTestScenarioData(testScenarioData)">
                        <i class="fas fa-trash-can"></i>
                    </button>
                    <div class="formRow">
                        <div class="dataProp">
                            <p><b>Attribute</b></p>
                            <p v-if="testScenarioData.attributeCode !== 'Other'">{{ testScenarioData.attributeCode }}</p>
                            <p v-if="testScenarioData.attributeCode === 'Other'">{{ testScenarioData.customAttributeCode }}</p>
                            <div class="flexBreak"></div>
                            <p class="attributeCode" v-if="testScenarioData.attributeCode">{{ getAttributeDescription(testScenarioData.attributeCode) }}</p>
                        </div>
                        <div class="dataProp">
                            <p><b>Data</b></p>
                            <select v-if="testScenarioData.questionType === 'SingleSelect'" v-model="testScenarioData.data" @blur="saveTestScenarioData(testScenarioData, 'data')">
                                <option v-for="answer in testScenarioData.answerValues" :key="answer">{{ answer }}</option>
                            </select>
                            <Multiselect v-else-if="testScenarioData.questionType === 'MultiSelect'" 
                                    v-model="testScenarioData.data"
                                    :options="testScenarioData.answerValues"
                                    placeholder="Type to search"
                                    open-direction="bottom"
                                    :multiple="true"
                                    :searchable="true"
                                    @focusout="saveTestScenarioData(testScenarioData, 'data')"
                                    @remove="saveTestScenarioData(testScenarioData, 'data')"></Multiselect>
                            <input v-else type="text" v-model="testScenarioData.data" @blur="saveTestScenarioData(testScenarioData, 'data')" />
                        </div>
                    </div>
                </div>
                <ItemModal :itemName="'Scenario Data'"
                        :formRows="testScenarioDataFormRows"
                        :saveItemFunction="saveNewTestScenarioData"
                        :refreshItemsFunction="getData"
                        :isActive="true"
                        :parentId="selectedScenario.id"></ItemModal>
        </div>
    </div>
</template>

<script>
import {data} from '../../shared/data';
import ItemModal from '@/components/ItemModal.vue';
import Multiselect from 'vue-multiselect';

export default {
    name: 'TestConfiguration',
    components: { ItemModal, Multiselect },
    data() {
        return {
            testConfiguration: null,
            attributes: [],
            surveys: [],
            selectedScenario: null,
            testScenarioFormRows: [
                {
                    name: 'Description',
                    propertyName: 'description',
                    required: true,
                    element: 'textarea'
                }
            ],
            testScenarioDataFormRows: [
                {
                    name: 'Attribute',
                    propertyName: 'attributeCode',
                    element: 'select',
                    required: {
                        propertyName: 'customAttributeCode',
                        equals: true,
                        value: false
                    },
                    selectOptions: []
                },
                {
                    name: 'Other Attribute',
                    propertyName: 'customAttributeCode',
                    required: {
                        propertyName: 'attributeCode',
                        equals: true,
                        value: 'Other'
                    },
                    element: 'input',
                    showIf: {
                        propertyName: 'attributeCode',
                        equals: true,
                        value: 'Other'
                    }
                },
                {
                    name: 'Data',
                    propertyName: 'data',
                    required: true,
                    element: 'input'
                }
            ]
        }
    },
    async mounted() {
        await this.getData();
    },
    methods: {
        goToAccordion: function() {
            window.location.href = '/accordionEdit?ID=' + this.testConfiguration.accordionID;
        },
        getData: async function() {
            let scenarioInd = 0;
            if(this.testConfiguration && this.selectedScenario)
                scenarioInd = this.testConfiguration.testScenarios.findIndex(ts => ts.id === this.selectedScenario.id);
            const urlParams = new URLSearchParams(window.location.search);
            this.testConfiguration = await data.getTestConfiguration(urlParams.get('id'));
            if(!this.testConfiguration.surveyCode)
                this.testConfiguration.surveyID = 0;
            this.surveys = await data.getAllSurveys('', true);
            this.attributes = await data.getAllAttributes('', true);
            this.attributes.unshift({code: 'Other'});
            this.testScenarioDataFormRows.find(row => row.propertyName === 'attributeCode').selectOptions = this.attributes.map(att => {return{displayName: att.code, internalName: att.code}});
            let attrs = this.attributes;
            this.testConfiguration.testScenarios.forEach(ts => {
                ts.testScenarioData.forEach(tsd => {
                    const attr = attrs.find(att => att.code === tsd.attributeCode);
                    if(!attr) {
                        tsd.customAttributeCode = tsd.attributeCode;
                        tsd.attributeCode = 'Other';
                    }
                })
            })
            this.selectedScenario = this.testConfiguration.testScenarios[scenarioInd];
            if(this.testConfiguration.survey) {
                this.testConfiguration.surveyID = this.testConfiguration.survey.id;
                if(this.selectedScenario)
                    this.processSurvey(this.testConfiguration.survey, this.selectedScenario);
            }  
            else
                this.testConfiguration.surveyID = 0;
        },
        processSurvey: function(survey, testScenario) {
            survey.pages.forEach(pg => {
                pg.questions.forEach(ques => {
                    if(ques.questionInfo.attribute) {
                        let tsd = testScenario.testScenarioData.find(tsd => tsd.attributeCode === ques.questionInfo.attribute.code);
                        if(tsd) {
                            tsd.questionType = ques.questionInfo.questionType;
                            tsd.answerValues = ques.questionInfo.answers.length ? ques.questionInfo.answers.map(ans => {return ans.answerValue}) : null;
                            if(ques.questionInfo.questionType === 'MultiSelect' && tsd.data)
                                tsd.data = tsd.data.split(',');
                        } else {
                            testScenario.testScenarioData.push({
                                questionType: ques.questionInfo.questionType,
                                attributeCode: ques.questionInfo.attribute.code,
                                answerValues: ques.questionInfo.answers.length ? ques.questionInfo.answers.map(ans => {return ans.answerValue}) : null
                            });
                        }
                    }
                })
            });
        },
        getAttributeDescription: function(code) {
            const attr = this.attributes.find(att => att.code === code);
            return attr ? attr.description : '';
        },
        saveTestConfiguration: async function(fieldName) {
            let obj = {};
            if(fieldName) {
                obj.id = this.testConfiguration.id,
                obj[fieldName] = this.testConfiguration[fieldName]
            } else {
                obj = this.testConfiguration;
            }
            this.processSaveResult(await data.saveTestConfiguration(obj));
        },
        saveTestScenario: async function(ts, fieldName) {
            let obj = {};
            if(fieldName) {
                obj.id = ts.id,
                obj[fieldName] = ts[fieldName]
            } else {
                obj = ts;
            }
            this.processSaveResult(await data.saveTestScenario(obj));
        },
        saveNewTestScenario: async function(ts) {
            ts.testConfigurationId = this.testConfiguration.id;
            return this.processSaveResult(await data.saveTestScenario(ts));
        },
        saveTestScenarioData: async function(tsd, fieldName) {
            if(!tsd.data) return;
            let obj = {};
            if(fieldName && tsd.id) {
                obj.id = tsd.id;
                if(fieldName === 'customAttributeCode')
                    obj.attributeCode = tsd.customAttributeCode;
                else if(fieldName === 'data' && tsd.questionType && tsd.questionType === 'MultiSelect') {
                    obj.data = tsd.data.toString();
                }
                else
                    obj[fieldName] = tsd[fieldName];
            } else {
                obj = tsd;
                if(tsd.questionType && tsd.questionType === 'MultiSelect') {
                    obj.data = tsd.data.toString();
                }
                obj.testScenarioID = this.selectedScenario.id;
            }
            const returnObj = this.processSaveResult(await data.saveTestScenarioData(obj, this.testConfiguration.id));
            if(!tsd.id)
                tsd.id = returnObj.id;
        },
        saveNewTestScenarioData: async function(scenarioId, tsd) {
            tsd.testScenarioId = scenarioId;
            if(tsd.customAttributeCode)
                tsd.attributeCode = tsd.customAttributeCode;
            const returnObj = this.processSaveResult(await data.saveTestScenarioData(tsd, this.testConfiguration.id));
            tsd.id = returnObj.id;
            return returnObj;
        },
        deleteTestScenario: async function() {
            if(confirm('Are you sure you want to delete this Test Scenario?')) {
                this.processDeleteResult(await data.deleteTestScenario(this.selectedScenario.id, this.testConfiguration.id));
                this.testConfiguration.testScenarios.splice(this.testConfiguration.testScenarios.map(ts => ts.id).indexOf(this.selectedScenario.id), 1);
                this.selectedScenario = this.testConfiguration.testScenarios.length ? this.testConfiguration.testScenarios[0] : null;
            }
        },
        deleteTestScenarioData: async function(tsd) {
            if(confirm('Are you sure you want to delete this row of data?')) {
                this.processDeleteResult(await data.deleteTestScenarioData(tsd.id, this.testConfiguration.id, this.selectedScenario.id));
                if(tsd.attributeCode === 'Other')
                    this.selectedScenario.testScenarioData.splice(this.selectedScenario.testScenarioData.map(tsd => tsd.id).indexOf(tsd.id), 1);
                else {
                    tsd.data = null;
                    tsd.id = null;
                }
            }
        },
        goToAccordionTest: function() {
            window.open('/AccordionTest?accordionCode=' + this.testConfiguration.accordionCode + '&testScenarioId=' + this.selectedScenario.id + '&testConfigurationId=' + this.testConfiguration.id, '_blank').focus();
        }
    }
}
</script>

<style scoped>
    .testConfiguration {
        width: 60%;
        margin: auto;
    }
    .guid {
        float: left;
    }
    .childObject {
        position: relative;
        margin-top: 20px;
    }
    .childObject textarea {
        display: block;
        width: 400px;
        height: 50px;
        margin-left: 20px;
        padding: 10px;
    }
    .grandChildObject {
        padding: 0 20px;
        position: relative;
    }
    .grandChildObject .formRow {
        align-items: flex-start;
    }
    .attributeCode {
        display: block;
    }
    .dataProp {
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
        flex: 1 1 200px;
        align-items: flex-start;
        margin: 0 10px;
    }
    .dataProp:last-child {
        margin-right: 40px;
    }
    .deleteButton {
        position: absolute;
        width: 40px;
        height: 40px;
        background-color: darkred;
        border-color: darkred;
        color: white;
        border-radius: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        right: 10px;
        top: 10px;
        z-index: 50;
    }
    .surveyCode {
        width: 100%;
        justify-content: center;
        margin-bottom: 20px;
    }
    .surveyCode p {
        margin-right: 20px;
    }
    .testButton {
        height: 40px;
        width: 200px;
        font-size: 16px;
        background-color: #036991;
        border-color: #036991;
        color: white;
        border-radius: 5px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        margin: auto;
        margin-top: 10px;
    }
</style>